import privacyPolicyMd from '../../../assets/legal-documents/privacy-policy.md?raw';
import termsOfServiceMd from '../../../assets/legal-documents/terms.md?raw';
import systemTermsOfServiceMd from '../../../assets/legal-documents/terms-of-service.md?raw';

export type LegalDocumentConfig = {
  slug: string;
  title: string;
  shortLabel: string;
  fileName: string;
  content: string;
  introduction: string;
  lastUpdated: string;
  description?: string;
};

const extractIntroduction = (markdown: string): string => {
  const lines = markdown.split('\n');
  const introLines: string[] = [];
  let foundTitle = false;
  let foundFirstH2 = false;

  for (const line of lines) {
    if (line.startsWith('# ')) {
      foundTitle = true;
      continue;
    }

    if (line.startsWith('## ') && foundTitle) {
      foundFirstH2 = true;
      break;
    }

    if (foundTitle && !foundFirstH2) {
      if (!line.includes('**Last Updated:**') && line.trim()) {
        introLines.push(line);
      }
    }
  }

  return introLines.join('\n').trim();
};

const removeIntroduction = (markdown: string): string => {
  const lines = markdown.split('\n');
  const contentLines: string[] = [];
  let foundFirstH2 = false;

  for (const line of lines) {
    if (line.startsWith('## ')) {
      foundFirstH2 = true;
    }

    if (foundFirstH2) {
      contentLines.push(line);
    }
  }

  return contentLines.join('\n').trim();
};

export const LEGAL_DOCUMENTS: Record<string, LegalDocumentConfig> = {
  terms: {
    slug: 'terms',
    title: 'Terms',
    shortLabel: 'Terms',
    fileName: 'terms.md',
    content: removeIntroduction(termsOfServiceMd),
    introduction: extractIntroduction(termsOfServiceMd),
    lastUpdated: '2025-12-01',
    description: 'Legal agreement for using Bhutan Payments services',
  },

  termsOfService: {
    slug: 'terms-of-service',
    title: 'Bhutan Payments Services Agreement',
    shortLabel: 'Terms of Service',
    fileName: 'terms-of-service.md',
    content: removeIntroduction(systemTermsOfServiceMd),
    introduction: extractIntroduction(systemTermsOfServiceMd),
    lastUpdated: '2025-12-01',
    description: 'Bhutan Payments Terms of Service',
  },

  privacy: {
    slug: 'privacy-policy',
    title: 'Privacy Policy',
    shortLabel: 'Privacy',
    fileName: 'privacy-policy.md',
    content: removeIntroduction(privacyPolicyMd),
    introduction: extractIntroduction(privacyPolicyMd),
    lastUpdated: '2025-12-01',
    description: 'How we collect, use, and protect your personal data',
  },
};

export const getLegalDocumentLinks = () => {
  return Object.values(LEGAL_DOCUMENTS).map((doc) => ({
    label: doc.shortLabel,
    href: `/legal/${doc.slug}`,
  }));
};

export const getLegalDocumentLinksExcluding = (excludeSlugs: string[]) => {
  return Object.values(LEGAL_DOCUMENTS)
    .filter((doc) => !excludeSlugs.includes(doc.slug))
    .map((doc) => ({
      label: doc.shortLabel,
      href: `/legal/${doc.slug}`,
    }));
};

export const getLegalDocumentBySlug = (slug: string): LegalDocumentConfig | undefined => {
  return Object.values(LEGAL_DOCUMENTS).find((doc) => doc.slug === slug);
};
